import TransferConfirmation from '../../../banking/components/transfers/TransferConfirmation';

const TransferConfirmationPage = () => {
    return <TransferConfirmation />;
};

export default TransferConfirmationPage;
